import _ from 'lodash';

export const DataConf = {
  initialState: {
    loading: false,
    error: null,
    data: [],
    meta: null,
  },
};

export const StatusLogbookDefault = [
  {
    id: 'NEW REQUEST',
    label: 'NEW REQUEST',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'CANCELLED',
    label: 'CANCELLED',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
];

export const StatusLogbookDeliveries = [
  {
    id: 'NEW REQUEST',
    label: 'NEW REQUEST',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'STAND-BY',
    label: 'STAND-BY',
    color: '#fff',
    backgroundColor: '#005488',
  },
  {
    id: 'SCHEDULED',
    label: 'SCHEDULED',
    color: '#fff',
    backgroundColor: '#ff6500',
  },
  {
    id: 'IN PROGRESS',
    label: 'IN PROGRESS',
    color: '#fff',
    backgroundColor: '#f6ca00',
  },
  {
    id: 'DELIVERED',
    label: 'DELIVERED',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'PICKED UP',
    label: 'PICKED UP',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'DECLINED',
    label: 'DECLINED',
    color: '#fff',
    backgroundColor: '#e74c3c',
  },
  {
    id: 'CANCELLED',
    label: 'CANCELLED',
    color: '#fff',
    backgroundColor: '#ff001b',
  },
  {
    id: 'IN STOCK',
    label: 'IN STOCK',
    color: '#fff',
    backgroundColor: '#00c256',
  },
  {
    id: 'NO DRIVER',
    label: 'NO DRIVER',
    color: '#fff',
    backgroundColor: '#565656',
  },
];

export const StatusLogbook = _.concat(
  _.map(StatusLogbookDefault, (item) => {
    return _.mapKeys(item, (value, key) => {
      switch (key) {
        case 'backgroundColor':
          return 'hex';
        case 'color':
          return 'textHex';
        default:
          return key;
      }
    });
  }),
  _.map(StatusLogbookDeliveries, (item) => {
    return _.mapKeys(item, (value, key) => {
      switch (key) {
        case 'backgroundColor':
          return 'hex';
        case 'color':
          return 'textHex';
        default:
          return key;
      }
    });
  })
);

export const AreaOptions = [
  {
    id: null,
    label: 'NONE'
  },
  {
    id: 'NORD',
    label: 'NORTH'
  },
  {
    id: 'SUD',
    label: 'SOUTH'
  },
  {
    id: 'CARIBBEAN',
    label: 'CARIBBEAN'
  },
];

export const PickupStatusOptions = [
  {
    id: 'COMPLETED',
    label: 'COMPLETED',
    color: '#1B5E20',
    backgroundColor: '#E8F5E9',
    borderColor: '#A5D6A7',
  },
  {
    id: 'IN PROGRESS',
    label: 'IN PROGRESS',
    color: '#8A5A00',
    backgroundColor: '#FFF8E1',
    borderColor: '#FFD58A',
  },
  {
    id: 'NOT STARTED',
    label: 'NOT STARTED',
    color: '#B71C1C',
    backgroundColor: '#FFEBEE',
    borderColor: '#EF9A9A',
  },
  {
    id: 'NO PICKUPS',
    label: 'NO PICKUPS',
    color: '#37474F',
    backgroundColor: '#ECEFF1',
    borderColor: '#B0BEC5',
  },
];

export const DefaultStatus = StatusLogbookDeliveries?.filter(
  (item) =>
    item?.id === 'NEW REQUEST' ||
    item?.id === 'STAND-BY' ||
    item?.id === 'SCHEDULED' ||
    item?.id === 'IN PROGRESS' ||
    item?.id === 'DELIVERED'
);

export const OPTIONS_STATUS_LOGBOOK = {
  DEFAULT: StatusLogbookDefault,
  DELIVERIES: StatusLogbookDeliveries,
  SHIPPING: StatusLogbookDeliveries
}

export const DefaultAreas = AreaOptions?.filter(
  (item) =>
    item?.id === null ||
    item?.id === 'NORD' ||
    item?.id === 'SUD'
);

export const DefaultAreasCaribbean = AreaOptions?.filter(
  (item) =>
    item?.id === 'CARIBBEAN'
);

